export const defaultValues = {
  treatmentStartDate: '',
  treatmentEndDate: '',
  policies: [],
  activePolicies: [],
  findPolicy: {
    searchType: 'policyNumber',
    policyNumber: '',
    email: '',
    postcode: '',
    postcodeMismatch: false,
  },
  selectPet: {},
  claimType: {
    type: undefined,
  },
  existingClaims: {
    existingClaims: [],
    hasDuplicates: false,
    claimForContinuation: undefined,
  },
  claimDetails: {
    claimAmount: undefined,
    subcoverages: [],
    conditionName: '', // Just for the form
    condition: {
      accident: '' as 'Yes' | 'No',
      conditionType: '',
      conditionName: '',
      algoliaID: '',
      conditionId: '',
      section: '',
    },
    payee: 'Your practice' as 'Your practice' | 'Policy holder',
    referral: 'No' as 'Yes' | 'No',
    referralPracticeName: '',
    referralHistory: [],
    requiredDocuments: {
      uploadInvoice: [],
      uploadTreatmentHistory: [],
      uploadSupportingDocs: [],
    },
    adviceNote: '',
    vetClaimRef: '',
  },
  documents: [],
  review: { agreedToTerms: false, claim: undefined },
}
